module.exports = __webpack_public_path__ + "static/media/image.015f22e7.png";